export default "__VITE_ASSET__BbDu_Bd0__"